import { IApi } from "../shared/iapi";
import { ICUser } from "../entities/icuser";

export class ICUserApi extends ICUser implements IApi<ICUser> {
  AreasId: number[];
  RolesId: number[];

  constructor(data?: Partial<ICUserApi>) {
    super(data);
    Object.assign(this, data);
  }
}
